import {reactive} from "vue";
import {WORKER_KEY} from "@/constants/localStorageKeys";

export const useSignupStore = () => {
  const state = reactive({})

  return {
    get worker() {
      return state
    },
    restoreWorker() {
      const worker = localStorage.getItem(WORKER_KEY)

      if (worker != null) {
        Object.assign(state, {}, JSON.parse(worker))
      }
    },
    setWorker(worker) {
      Object.assign(state, worker)
      localStorage.setItem(WORKER_KEY, JSON.stringify(state))
    }
  };
}
